type TickInCircleIconProps = {
  isFilled: boolean;
  visuallyHiddenClass: string | undefined;
};

export const TickInCircleIcon = ({
  isFilled = false,
  visuallyHiddenClass,
}: TickInCircleIconProps) => {
  const tickScreenReaderText = isFilled ? "Completed" : "In progress";
  if (isFilled) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        role="image"
      >
        {visuallyHiddenClass && (
          <title className={visuallyHiddenClass}>{tickScreenReaderText}</title>
        )}
        <path
          d="M12.9091 5.23945L12.3788 4.70912L11.8485 5.23944L6.83807 10.2498L5.89679 9.30849L5.36646 8.77816L4.83613 9.30849L3.77547 10.3691L3.24514 10.8995L3.77547 11.4298L6.30773 13.9621L6.83806 14.4924L7.36839 13.9621L13.9698 7.36078L14.5001 6.83045L13.9698 6.30012L12.9091 5.23945ZM17.25 9C17.25 13.5563 13.5563 17.25 9 17.25C4.44365 17.25 0.75 13.5563 0.75 9C0.75 4.44365 4.44365 0.75 9 0.75C13.5563 0.75 17.25 4.44365 17.25 9Z"
          fill="#141414"
          stroke="#141414"
          strokeWidth="1.5"
        />
      </svg>
    );
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      role="image"
    >
      {visuallyHiddenClass && (
        <title className={visuallyHiddenClass}>{tickScreenReaderText}</title>
      )}
      <path
        d="M12.3788 5.76978L6.83807 11.3104L5.36646 9.83882L4.3058 10.8995L6.83806 13.4317L13.4395 6.83044L12.3788 5.76978Z"
        fill="#cccccc"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
        fill="#cccccc"
      />
    </svg>
  );
};
